<template>
  <div>
    <MainNav />

    <RouterView />
  </div>
</template>

<script>
  import MainNav from '@/components/Main/Nav';

  export default {
    components: {
      MainNav,
    },
  };
</script>
